import { Button, Form, message, Input, Col, Row } from 'antd';
import AppHeader from 'components/AppHeader';
import React, { useState, useEffect } from 'react';
import statisticApis from 'api/statisticApis';
import { ContentRow } from 'components/ThemeComponents';
import { StyledTable, OFFSET_HEADER } from 'components/ThemeComponents';
import { fullDateTimeFormat } from 'helpers/dateTimeHelper';

export default function TenantDetailStatisticsPage() {

  const [statistics, setStatistics] = useState([]);

  const [form] = Form.useForm();

  async function fetchTenantDetailsInfo(tenant_id, params={}) {
    try {
      const res = await statisticApis.tenant_details(tenant_id, params);
      setStatistics(res);
    } catch (error) {
      message.info(error.message);
    }
  }

  const onFinish = (values) => {
    const { tenant_id } = values;
    if (tenant_id) {
      fetchTenantDetailsInfo(tenant_id);  // Pass the tenant_id as a string
    } else {
      message.error('Please enter a valid tenant ID');
    }
  };
  
  return (
    <>
      <h1>TenantDetails Statistics</h1>
      <Form form={form} layout="inline" onFinish={onFinish}>
        <Form.Item
          name="tenant_id"
          rules={[{ required: true, message: 'Please input tenant ID!' }]}
        >
          <Input 
            placeholder="Enter Tenant ID"
            style={{ width: '500px' }}
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Filter
          </Button>
        </Form.Item>
      </Form>
      <pre>{JSON.stringify(statistics, null, 2)}</pre>
    </>
  );
}
